export default __webpack_public_path__ + "static/media/mainbg.1067f58d.jpg";